import Language from '../../../i18n/Language';

const t = Language;

export const GSC_GREEN = '#27AE60';
export const GSC_RED = '#E51C00';

// GSC 列（顺序需与表头 Clicks / Impressions / CTR / Avg.position 保持一致）
export const GSC_COLUMNS = ['clicks', 'impressions', 'ctr', 'position'];

// 三角趋势图标：up 决定朝向，color 决定颜色
export const TrendTriangle = ({ type, up, color }) => (
    ((up && type !== 'position') || (!up && type === 'position'))
        ? <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.23178 5.92186C7.63158 5.44211 8.36843 5.44211 8.76822 5.92187L11.6332 9.35981C12.176 10.0111 11.7128 11 10.865 11H5.13504C4.2872 11 3.82405 10.0111 4.36682 9.35981L7.23178 5.92186Z" fill={color} />
        </svg>
        : <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.76822 10.0781C8.36842 10.5579 7.63157 10.5579 7.23178 10.0781L4.36682 6.64019C3.82405 5.98886 4.2872 5 5.13504 5L10.865 5C11.7128 5 12.176 5.98886 11.6332 6.64019L8.76822 10.0781Z" fill={color} />
        </svg>
);

// 数值格式化：ctr 显示百分比，position 保留 1 位小数，点击/展示量做 K/M 缩写
export const formatGscValue = (key, value) => {
    const v = Number(value) || 0;
    if (key === 'ctr') return `${(v * 100).toFixed(2)}%`;
    if (key === 'position') return v.toFixed(1);
    if (v >= 1000000) return `${(v / 1000000).toFixed(1)}M`;
    if (v >= 1000) return `${(v / 1000).toFixed(1)}K`;
    return `${v}`;
};

// 计算环比变化：up 为数值方向，good 表示是否为正向变化（position 越低越好）
export const getGscTrend = (key, current, previous) => {
    const cur = Number(current) || 0;
    const prev = Number(previous) || 0;
    const delta = cur - prev;
    const up = delta > 0;
    const good = key === 'position' ? delta < 0 : delta > 0;
    let percent = 0;
    if (prev !== 0) percent = Math.abs(delta / prev) * 100;
    else if (cur !== 0) percent = 100;
    return { up, good, delta, percent: Math.round(percent) };
};

// 单元格内的趋势图标（无变化时不展示）
export const gscCellTrend = (key, current, previous) => {
    const { up, good, delta } = getGscTrend(key, current, previous);
    if (delta === 0) return null;
    return <span className='flex_layout'><TrendTriangle type={key} up={up} color={good ? GSC_GREEN : GSC_RED} /></span>;
};

// Tooltip 内容：Last 28d / Prev. 28d / Change
export const gscTooltipContent = (key, current, previous) => {
    const { up, good, delta, percent } = getGscTrend(key, current, previous);
    return <div className='data_28d_view'>
        <p>
            <span>{t("Last 28d")}</span>
            <span>{formatGscValue(key, current)}</span>
        </p>
        <p>
            <span>{t("Prev. 28d")}</span>
            <span>{formatGscValue(key, previous)}</span>
        </p>
        <p>
            <span>{t("Change")}</span>
            <span className='table_perc_view'>
                {delta !== 0 && <span className='flex_layout'><TrendTriangle type={key} up={up} color={good ? GSC_GREEN : GSC_RED} /></span>}
                {
                    previous === 0 ? current : `${percent}%`
                }
            </span>
        </p>
    </div>;
};
